import _ from 'lodash';
import React from 'react';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Sprites from '../components/Sprites';
import useMediaQuery from '../hooks/useMediaQuery';

export default function FreeZoneDownloadActivitiesList({ data, id }) {
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const title = _.get(data, 'downloadTitle', '');
  const text = _.get(data, 'downloadText', '');
  const englishButton = _.get(data, 'englishButton', {});
  const arabicButton = _.get(data, 'arabicButton', {});
  const bgImage = _.get(data, 'bgImage', '');
  const bgImageMobile = _.get(data, 'bgImageMobile', '');

  // console.log(isDesktop);

  return (
    <section id={id} className="px-6 3xl:px-0 pb-[50px] md:pb-[100px] pt-10 lg:pt-0">
      <div className="max-w-[970px] relative mx-auto">
        <div
          className="relative z-10 bg-white bg-opacity-75 py-5 md:py-[34px] px-[10px]
          md:px-[61px] rounded-[4px] md:rounded-[8px] flex flex-col md:flex-row gap-5 md:gap-[62px]
          ">
          <div
            className="md:max-w-[564px] flex flex-col md:flex-row gap-[15px] md:gap-[25px]
            items-center">
            <div className="svg-path:stroke-[#CE445B]">
              <Sprites name="download" className="w-[25px] md:w-[35px] h-[25px] md:h-[35px]" />
            </div>

            <div className="flex flex-col md:flex-row gap-[6px] md:gap-[18px] items-center">
              <h4
                className="text-clamp13to20 ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium text-[#231F20] font-medium
              leading-[100%]">
                {title}
              </h4>
              <p
                className="text-[12px] md:text-[13px] !mb-0 text-[#4A4A4A] font-normal
              ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight leading-[100%]">
                {text}
              </p>
            </div>
          </div>
          <div
            className="flex flex-col md:flex-row gap-[10px] md:gap-[15px] md:items-start
          items-center">
            {_.isEmpty(englishButton) || (
              <Link
                href={englishButton.url}
                target={englishButton.target}
                className="w-[176px] md:w-[103px] flex justify-center items-center rounded-[48px]
                bg-[#CE445B] text-white uppercase ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium ltr:tracking-[1.2px]
                leading-1 h-[36px] md:h-[40px] text-[11px] md:text-[12px] lg:text-[14px] hover:bg-[#B53B50]">
                {englishButton.name}
              </Link>
            )}
            {_.isEmpty(arabicButton) || (
              <Link
                href={arabicButton.url}
                target={arabicButton.target}
                className="w-[176px] md:w-[103px] flex justify-center items-center rounded-[48px]
                bg-transparent text-[#333] uppercase ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium ltr:tracking-[1.2px]
                leading-1 h-[36px] md:h-[40px] text-[11px] md:text-[12px] lg:text-[14px] border border-[#333]">
                {arabicButton.name}
              </Link>
            )}
          </div>
        </div>
        {(isDesktop && _.isEmpty(bgImage)) || (
          <LazyLoadImage
            src={bgImage.url}
            width="100%"
            className="absolute inset-0 object-cover h-full w-full rounded-[4px] md:rounded-[8px]"
          />
        )}
        {isDesktop || _.isEmpty(bgImageMobile) || (
          <LazyLoadImage
            src={bgImageMobile.url}
            width="100%"
            className="absolute inset-0 object-cover h-full w-full rounded-[4px] md:rounded-[8px]"
          />
        )}
      </div>
    </section>
  );
}
